import { Injector } from '@angular/core';
import { GetDataPointsService } from './get-data-points.service';
import { GoogleAnalyticsService } from './google-analytics.service';

export class AnalyticsBase {
  protected _googleAnalyticsService: GoogleAnalyticsService;
  protected _getDataPointsService: GetDataPointsService;

  constructor(injector: Injector) {
    this._googleAnalyticsService = injector.get(GoogleAnalyticsService);
    this._getDataPointsService = injector.get(GetDataPointsService);
  }

  captureClick(event, prefix?: string) {
    const path = this.getEventPath(event, prefix);
    this._googleAnalyticsService.trackPageEvents('click', path);
  }

  getEventPath(event, prefix?: string) {
    const { currentTarget } = event;
    const { innerText } = currentTarget;
    this._getDataPointsService.getElement(currentTarget, 'dls-page-section');
    const path = [
      this._getDataPointsService.getMainSectionHeading(),
      this._getDataPointsService.getSubSectionHeading(),
      this._getDataPointsService.getActiveCodeTab(),
      prefix,
      innerText,
    ];
    return path.join('').toUpperCase();
  }
}
